import { Text } from "@/components/ui/baseUi/text"
import type { MediaItemFormType } from "@/modules/common/media/mediaFormTypes"
import { cn } from "@/modules/lib/utils"
import { type MediaBlockItemFormikType } from "@/modules/sessions/sessionForm/blocks/mediaBlock/mediaBlockFormikTypes"
import { word } from "@modules/core/utils/i18n"
import { YouTubeVideoPlayer } from "@modules/utils/components/youTubeVideo"
import { convertYoutubeLinkToEmbed } from "@modules/utils/mediaUtils"

type MediaExistingBlockYoutubeProps = {
  media: MediaBlockItemFormikType | MediaItemFormType
  className?: string
} & React.ComponentProps<"div">

export function MediaExistingBlockYoutube({ media, className, ...props }: MediaExistingBlockYoutubeProps) {
  return (
    <div className={cn("flex flex-row items-center gap-3", className)} {...props}>
      {media.url ? (
        <YouTubeVideoPlayer
          link={convertYoutubeLinkToEmbed(media.url)}
          height={102}
          width={179}
          className="max-w-max overflow-hidden rounded-4xl"
        />
      ) : (
        <Text fontStyle="BM" className="wrap-break-word">
          {word("sessionForm.blocks.add_media.missing_error")}
        </Text>
      )}
      <Text fontStyle="BM" className="wrap-break-word">
        {word("sessionForm.blocks.add_media.youtube_link.label")}
      </Text>
    </div>
  )
}
